import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authInitState, logoutRequest } from 'redux/reducers/auth/reducer';
import { userInitState } from 'redux/reducers/user/reducer';
import { getAuthRefreshToken } from 'redux/reducers/auth/selectors';
import { TScreensaverProps } from './types';
import { CircularProgressWithLabel } from './Progress';

const SCREENSAVER_TIMEOUT = 20;

export const Screensaver2FA: FC<TScreensaverProps> = ({ open, type }) => {
	const refreshToken = useSelector(getAuthRefreshToken);
	const dispatch = useDispatch();
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		// if (!open) return () => {};
		const timer = setInterval(() => {
			if (!open) return;
			setProgress((prevProgress) => (prevProgress >= SCREENSAVER_TIMEOUT ? 0 : prevProgress + 1));
			if (progress === SCREENSAVER_TIMEOUT) {
				if (refreshToken) dispatch(logoutRequest({ token: refreshToken }));
				dispatch(authInitState());
				dispatch(userInitState());
				clearInterval(timer);
				setProgress(0);
			}
		}, 1000);
		return () => {
			clearInterval(timer);
		};
	}, [progress, dispatch, open, refreshToken]);

	const handleReload = () => {
		setProgress(SCREENSAVER_TIMEOUT);
	};

	return (
		<Dialog
			open={open}
			sx={{
				backdropFilter: 'blur(5px)',
				backgroundColor: '#01619589',
				'& .MuiDialog-paper': {
					backgroundColor: 'transparent',
					boxShadow: 'none',
					maxWidth: '360px',
				},
			}}
		>
			<DialogTitle variant="h6" color="#fff" id="alert-dialog-title">
				{type === 'enable'
					? 'You will be redirected to the login page and subsequently guided through the process of configuring two-factor authentication (2FA)'
					: 'It is strongly recommended to keep two-factor authentication (2FA) enabled as disabling it will lower your security level'}
			</DialogTitle>
			<DialogContent
				sx={{
					paddingTop: 20,
					paddingBottom: 20,
				}}
			>
				<Box
					style={{
						position: 'absolute',
						top: '60%',
						left: '50%',
						transform: 'translate(-50%, -50%)',
						fontSize: '60px',
						fontWeight: 'bold',
						color: SCREENSAVER_TIMEOUT - progress < 10 ? `#ff7fa4` : '#fff',
					}}
				>
					{SCREENSAVER_TIMEOUT - progress}
				</Box>
			</DialogContent>
			<DialogActions disableSpacing sx={{ justifyContent: 'center' }}>
				<Button
					autoFocus
					variant="contained"
					size="large"
					sx={{
						color: '#fff',
						borderRadius: '50px',
						boxShadow: 'none',
						border: '1px solid #fff',
						fontSize: '20px',
						textTransform: 'none',
					}}
					onClick={handleReload}
				>
					Reload now
				</Button>
			</DialogActions>
		</Dialog>
	);
};
